import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { tap, withLatestFrom } from "rxjs";
import { sidebarExpanded } from "./page-state.selectors";
import { GeneralStateAction } from "./page-state.actions";

@Injectable()
export class GeneralStateEffects {

  private actions$: Actions = inject(Actions);
  private store: Store = inject(Store);
  

  setSidebarExpanded$ = createEffect(() =>
    this.actions$.pipe(ofType(GeneralStateAction.setSidebarExpanded),
      tap((state) => {
        localStorage.setItem('isSidenavOpen', JSON.stringify(state.sidebarExpanded));
      }
      )),
    { dispatch: false }
  );

  toggleSidebarExpanded$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeneralStateAction.toggleSidebarExpanded),
      withLatestFrom(this.store.select(sidebarExpanded)),
      tap(([a, isExpanded]) => {
        localStorage.setItem('isSidenavOpen', JSON.stringify(isExpanded));
      })
    ),
    { dispatch: false }
  );
}